export function sleep(timeMs) {
  return new Promise((resolve) => {
    setTimeout(resolve, timeMs);
  });
}
const defaultOptions = {
  maxRetries: 100,
  timeout: 1e3
};
export async function awaitRefreshToken(HANDLER, options = defaultOptions) {
  let count = 0;
  const fnOptions = { ...defaultOptions, ...options };
  while (HANDLER === "pending" && count < fnOptions.maxRetries) {
    await new Promise((resolve) => {
      setTimeout(resolve, fnOptions.timeout);
      count++;
    });
  }
  if (count > fnOptions.maxRetries) {
    console.log("Max retries reached");
    throw new Error("Max retries reached");
  }
  return count;
}
